<template>
  <div class="dropdown dropdown-company-action">
    <button class="btn-outline btn btn-xs btn-info dropdown-toggle" :id="'dropdownMenu-'+company.authorID"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" :class="{active: company.selected}">
      <i class="pe-7s-more pe-1x fa-rotate-90"></i>
    </button>
    <ul class="dropdown-menu pull-right" aria-labelledby="dropdownMenu1" style="float: right" >
      <template v-if="context.name === 'expertSelected'">
        <li><a role="button" @click="dropDownClick('removeCompany', $event)"><i class="fa fa-trash text-danger"></i> Remove Company</a></li>
        <li v-if="nameToQuery">
          <router-link :to="{name: 'Search', params: {query: nameToQuery}, query: { typeSearched : 3 }}"><i class="fa fa-search text-warning"></i> Search Company</router-link>
        </li>
      </template>
      <template v-else-if="context.name === 'expertSimilar'">
        <li><a role="button" @click="dropDownClick('addCompany', $event)"><i class="fa fa-plus text-success"></i> Add Company</a></li>
        <li v-if="nameToQuery">
          <router-link :to="{name: 'Search', params: {query: nameToQuery}, query: { typeSearched : 3 }}"><i class="fa fa-search text-warning"></i> Search Company</router-link>
        </li>
        <li><a role="button" @click="dropDownClick('removeCompany', $event)"><i class="fa fa-trash text-danger"></i> Remove Company</a></li>
      </template>
      <template v-else-if="context.name === 'expertResult'">
        <template v-if="company.selected">
          <li ><a role="button" @click="dropDownClick('removeCompany', $event)"><i class="fa fa-trash text-danger"></i> Remove Company</a></li>
          <li v-if="company.similar_authors.length !== 0"><a role="button" @click="dropDownClick('addSimilarCompany', $event)"><i class="fa fa-users text-success"></i> Add Company & {{company.similar_authors.length}} similars</a></li>
          <li v-if="nameToQuery">
            <router-link :to="{name: 'Search', params: {query: nameToQuery}, query: { typeSearched : 3 }}"><i class="fa fa-search text-warning"></i> Search Company</router-link>
          </li>
        </template>
        <template v-else>
          <li><a role="button" @click="dropDownClick('addCompany', $event)"><i class="fa fa-plus text-success"></i> Add Company</a></li>
          <li v-if="company.similar_authors.length !== 0"><a role="button" @click="dropDownClick('addSimilarCompany', $event)"><i class="fa fa-users text-success"></i> Add Company & {{company.similar_authors.length}} similars</a></li>
          <li :id="'dropdown-submenu-merge-'+company.authorID" class="dropdown-submenu">
            <a tabindex="-1" class="test" href="#"><i class="fa fa-copy text-warning"></i> Replace Company <span class="fa fa-caret-down"></span></a>
            <ul class="dropdown-menu">
              <template v-if="context.selected && context.selected.length">
                <li v-for="(listCompany, key) in context.selected" v-if="listCompany.firstName === null" :key="key">
                  <div style="font-size: 12px; padding: 3px 20px" @click="subMenuDropDownClick('mergeCompany', listCompany, $event)">
                    <a>{{listCompany.lastName}}</a>
                  </div>
                </li>
              </template>
              <template v-else>
                <li style="padding: 15px">Company list empty</li>
              </template>
            </ul>
          </li>
          <li v-if="nameToQuery">
            <router-link :to="{name: 'Search', params: {query: nameToQuery}, query: { typeSearched : 3 }}"><i class="fa fa-search text-warning"></i> Search Company</router-link>
          </li>
        </template>

      </template>
    </ul>
    <div v-if="replaceCompanyModal" class="modal fade" id="modalReplaceCompany" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title text-left">Company replacement</h4>
          </div>
          <div class="modal-body text-left">
            <div>Do you really want to replace this company?</div>
          </div>
          <div class="modal-footer">
            <button type="button" id="modalReplaceCompanyClose" class="btn btn-default">Close</button>
            <button type="button" id="modalReplaceCompanyConfirm" class="btn btn-info">Confirm</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .dropdown-suggestion > ul > li i{
    color: #ffc107;
    font-weight: bold;
  }

  .dropdown-suggestion > ul > li a{
    font-size: 12px;
  }

  .dropdown-suggestion > ul > li{
    margin-bottom: 5px;
    font-size: 12px;
  }

  .dropdown-submenu {
    position: relative;
  }

  .dropdown-submenu .dropdown-menu {
    top: 0;
    left: -220px;
    margin-top: -1px;
    overflow-y: scroll;
    max-height: 200px;
    width: 220px;
  }

</style>
<script>

export default {
  components: {},
  props: ['value', 'context'],
  name: 'DropdownCompany',
  data () {
    return {
      company: null,
      replaceCompanyModal: false,
      nameToQuery: null
    }
  },
  watch: {
    value: function (value) {
      this.company = value
    }
  },
  methods: {
    dropDownClick: function (action, event) {
      switch (action) {
        case 'removeCompany':
          this.company.selected = false
          this.$emit('input', Object.assign({}, this.company))
          this.context.removeCompany(this.company)
          break
        case 'addCompany':
          this.company.selected = true
          this.$emit('input', Object.assign({}, this.company))
          this.context.addCompany(this.company, 'company')
          break
        case 'addSimilarCompany':
          this.context.addCompanySimilar(this.company, 'company')
          break
      }

      $('#dropdownMenu-' + this.company.authorID).dropdown('toggle')

      if (typeof event.stopPropagation !== 'undefined') {
        event.stopPropagation()
      }
    },
    subMenuDropDownClick: function (action, element, event) {
      switch (action) {
        case 'mergeCompany':
          this.replaceCompanyModal = true
          setTimeout(() => {
            $('#modalReplaceCompany').modal('toggle')
            $('#modalReplaceCompanyConfirm').on('click', (e) => {
              this.company.selected = false
              this.$emit('input', Object.assign({}, this.company))
              this.context.mergeCompany(element, this.company)
              e.stopPropagation()
              $('#modalReplaceCompany').modal('toggle')
              this.replaceCompanyModal = false
            })
            $('#modalReplaceCompanyClose').on('click', (e) => {
              $('#modalReplaceCompany').modal('toggle')
              this.replaceCompanyModal = false
              e.stopPropagation()
            })
          }, 200)

          break
      }

      let submenu = $('#dropdown-submenu-merge-' + this.company.authorID + ' a.test')
      submenu.children('span').toggleClass('fa-caret-down').toggleClass('fa-caret-left')

      submenu.next('ul').toggle()

      $('#dropdownMenu-' + this.company.authorID).dropdown('toggle')

      if (typeof event.stopPropagation !== 'undefined') {
        event.stopPropagation()
      }
    }
  },
  beforeMount () {
    this.company = this.value
  },
  mounted () {
    $('#dropdown-submenu-merge-' + this.company.authorID + ' a.test').on('click', function (e) {
      $(this).children('span').toggleClass('fa-caret-down').toggleClass('fa-caret-left')

      $(this).next('ul').toggle()
      e.stopPropagation()
      e.preventDefault()
    })

    this.nameToQuery = 'name:"' + this.company.lastName + '"'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/DropdownCompany.vue